export default "__VITE_ASSET__BnvruCPy__"